<template>
  <div>
    <navbar-top></navbar-top>
    <navbar-left></navbar-left>
    <div class="board-list">
      <div class="board-list-wrapper">
        <div class="item-wrapper" v-for="p in boardList" :key="p.id">
          <div class="img-wrapper">
            <img class="logo" v-bind:src="getImgUrl('./board.png')" />
          </div>
          <div
            data-dz-thumbnail-bg-overlay
            class="data-dz-thumbnail-bg-overlay"
          >
            <ul class="tools">
              <li data-dz-delete class="delete" v-on:click="removeElement(p)">
                <a>delete</a>
              </li>
            </ul>
            <div class="checker">
              <span data-dz-checkbox>
                <input type="checkbox" />
              </span>
              <div>
                <a class="btn-oval" @click="goTo(p)">Anzeigen</a>
              </div>
            </div>
          </div>
          <h2>{{ p.name }}</h2>
          <p>Last Update:</p>
        </div>
      </div>
    </div>
    <div class="button-wrapper">
      <div
        class="plus-button"
        v-on:click="
          goTo({
            id: newID(),
            name: 'Flow ' + new Date().toLocaleTimeString(),
            tasks: [],
          })
        "
        ref="plusButton"
      >
        +
      </div>
    </div>
  </div>
</template>

<script>
//import boardFiles from '../assets/files/board/*.json'
import NavbarTop from './NavbarTop.vue';
import NavbarLeft from './NavbarLeft.vue';
import AmplifyStore from '../store/store';

export default {
  name: 'BoardList',
  data() {
    return {
      boardList: [],
    };
  },
  methods: {
    newID: function () {
      return Math.round(
        Math.random() * 100000 +
          (new Date().getTime() - Math.random() + Math.random())
      );
    },
    fetchData() {
      var token = this.user.signInUserSession.accessToken.jwtToken;
      var url = this.databaseApi();
      url += '/board?token=' + token;
      fetch(url)
        .then((data) => data.json())
        .then((json) => (this.boardList = JSON.parse(json)));
    },
    getImgUrl: function (img) {
      var images = require.context('../assets/img/', false, /\.png$/);
      return images(img);
    },
    goTo(board) {
      this.$router.push({
        name: 'board',
        params: {
          board: board,
          section: this.$route.params.section,
          title: board.name,
        },
      });
    },
    databaseApi: function () {
      return 'https://ty10sev90j.execute-api.eu-central-1.amazonaws.com/dev';
    },
    removeElement: function (p) {
      var id = p.id;

      //set API params
      var url = this.databaseApi();
      url += '/flow/' + id;

      //call api
      fetch(url, { method: 'delete' })
        .then((data) => data.json())
        .then((json) => {
          return;
        });

      this.boardList = this.boardList.filter((x) => {
        return x.id != id;
      });
    },
  },
  components: {
    NavbarLeft,
    NavbarTop,
  },
  mounted: function () {
    this.fetchData();
  },
  computed: {
    user() {
      return AmplifyStore.state.user;
    },
  },
};
</script>

<style scoped>
.board-list-wrapper {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: auto;
  width: 100%;
  min-height: 700px;
}

.item-wrapper {
  display: block;
  position: relative;
  float: left;
  width: 360px;
  height: 285px;
  border-radius: 4px;
  background: #fff;
  text-align: center;
  margin: 0 47px 40px 0;
  -webkit-box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
}

.item-wrapper h2 {
  color: #424956;
  font-size: 19px;
  font-weight: 400;
  line-height: inherit;
  margin-top: 15px;
}

.board-list-wrapper {
  width: 100%;
  padding: 60px 49px;
}

.img-wrapper {
  width: 100%;
  height: 187px;
  overflow: hidden;
}

.logo {
  position: absolute;
  width: 79%;
  position: relative;
  top: 62%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}

p {
  margin: 0 30px;
}

.button-wrapper {
  margin-top: -852px;
}

.plus-button {
  text-align: center;
}

.data-dz-thumbnail-bg-overlay:hover {
  opacity: 1;
}

.data-dz-thumbnail-bg-overlay {
  z-index: 5;
  top: 0;
  overflow: hidden;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  left: 0;
  height: 180px;
  width: 100%;
  position: absolute;
  top: 0;
  opacity: 0;
  background-color: rgba(25, 29, 38, 0.85);
  -webkit-transition: opacity 450ms ease-in-out;
  -o-transition: opacity 450ms ease-in-out;
  transition: opacity 450ms ease-in-out;
}

a.btn-oval {
  font-family: brandon-grotesque, 'Open Sans', open-sans, sans-serif;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  top: 86px;
  left: 97px;
  width: 166px;
  height: 36px;
  line-height: 36px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 36px;
  color: #fff;
  transition: all 0.2s ease-in-out;
  z-index: 2;
  position: absolute;
  text-decoration: none;
}

a.btn-oval:hover {
  color: rgba(25, 29, 38, 0.85);
  background-color: white;
}

.tools li.delete a {
  background-position: -129px -759px;
}

.tools {
  position: absolute;
  right: 17px;
  top: 7px;
  z-index: 2;
  border: 0px solid transparent;
  -webkit-transition: visibility 0s ease 450ms, -webkit-box-shadow 0.2s ease;
  -o-transition: visibility 0s ease 450ms, box-shadow 0.2s ease;
  transition: visibility 0s ease 450ms, box-shadow 0.2s ease;
  transition: visibility 0s ease 450ms, box-shadow 0.2s ease,
    -webkit-box-shadow 0.2s ease;
}

.tools li {
  float: left;
  list-style: none;
  cursor: pointer;
  padding: 0;
  margin: 0 0 0 12px;
}

.tools a {
  text-indent: -9999px;
}

.tools li > a {
  zoom: 1.2;
  opacity: 0.7;
  background-image: url('../assets/img/project-sprite.png');
  background-size: 882px 840px;
  background-position: -868px -268px;
  width: 14px;
  height: 13px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  -webkit-transition: opacity 0.2s ease-in-out;
  -o-transition: opacity 0.2s ease-in-out;
}

.tools li > a:hover {
  opacity: 1;
}

.tools li.share a {
  background-position: -868px -268px;
}

.tools li.delete a {
  background-position: -129px -759px;
}
</style>
